import _ from 'lodash';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { WppTextareaInput, WppTypography } from 'buildingBlocks';
import { TextareaInputChangeEventDetail, WppTextareaInputCustomEvent } from 'utils/types';
import { bulkUploaderStyles } from 'containers/BulkCreateStrategyWizard/steps/AttachFlights/style';
import { useBulkCreateAttachModalContext } from 'containers/BulkCreateStrategyWizard/steps/AttachFlights/contexts/BulkCreateAttachModalProvider';

const { bulkTextArea } = bulkUploaderStyles;

type Props = {
  setBulkFlightIds: (ids: Array<number>) => void
  shouldShowFileErr: boolean
};

export const BulkUploaderTextArea = (props: Props) => {
  const { setBulkFlightIds, shouldShowFileErr } = props;
  const { flightCandidateInfo: { loadingFlightCandidates } } = useBulkCreateAttachModalContext();
  const member = useWatch({ name: 'member' });

  const onTextChange = (value: string) => {
    const inputIds = _.filter(_.split(value, /\W+/), _.negate(_.isEmpty));
    setBulkFlightIds(inputIds);
  };

  return (
    <>
      <WppTypography type="s-strong">Object ID</WppTypography>
      <WppTextareaInput
        style={bulkTextArea}
        placeholder="Input Object IDs"
        message={!shouldShowFileErr ? 'Please paste no more than 500 elements.' : ''}
        onWppChange={(event: WppTextareaInputCustomEvent<TextareaInputChangeEventDetail>) => onTextChange(event.detail.value)}
        disabled={!member || loadingFlightCandidates}
        messageType={shouldShowFileErr ? 'error' : null}
      />
    </>
  );
};

export default BulkUploaderTextArea;
